<template>
    <myOrgCrSn url="org-cr-sn/list"></myOrgCrSn>
</template>

<script>
    import myOrgCrSn from "../../../components/myOrgCrSn"
    export default {
        name:'report-orgcr', //文件名称
        components:{
            myOrgCrSn
        },
        data:function(){
            return{
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/report/orgcr/list.vue